import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { UIHeading2 } from '@cian/ui-kit';
import * as styles from './FreshPromoList.css';
import { INewbuildingPromo } from '../../types/promosPage';
import { FreshPromoCard } from '../FreshPromoCard';
import { PromoPreviewList } from '../PromoPreviewList';
import { RoundArrowLeft } from '../RoundArrowLeft';
import { RoundArrowRight } from '../RoundArrowRight';
import { VerticalSlider } from '../VerticalSlider';

interface IFreshPromoListProps {
  title: string;
  promoList: INewbuildingPromo[];
  onCardView(position: number, promo: INewbuildingPromo): void;
  onCardClick(position: number, promo: INewbuildingPromo): void;
}

export const FreshPromoList: React.FC<IFreshPromoListProps> = ({ title, promoList, onCardView, onCardClick }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['header']}>
        <UIHeading2 as="h2" color="black_100">
          {title}
        </UIHeading2>
      </div>
      <VerticalSlider rightArrow={RoundArrowRight} leftArrow={RoundArrowLeft}>
        {promoList.map((promoItem, index) => {
          const { newbuildingId, newbuildingName, newbuildingImage, promoInfoList, promoName } = promoItem;

          const position = index + 1;

          return (
            <ActionAfterViewObserver
              key={newbuildingId}
              triggerOnce={true}
              callback={() => onCardView(position, promoItem)}
            >
              <div className={styles['slide']}>
                <FreshPromoCard
                  title={newbuildingName}
                  subtitle={promoName}
                  backgroundImage={newbuildingImage}
                  additionalPromoList={
                    promoInfoList && promoInfoList.length > 0 ? <PromoPreviewList promos={promoInfoList} /> : null
                  }
                  onClick={() => onCardClick(position, promoItem)}
                />
              </div>
            </ActionAfterViewObserver>
          );
        })}
      </VerticalSlider>
    </div>
  );
};
